var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, DotsLoader, Form, Icon, Modal, SubmitButton } from "@brushfire/ui";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { putCancelAttendee } from "../../../data/api";
import { setPaymentRequiredPayload } from "../../../store/PostAttendeeActions/actions";
import { PaymentPayloadType } from "../../../store/PostAttendeeActions/types";
import { useDispatch } from "react-redux";
import { handleErrors, handleSubmittedOrder } from "../../../data/helpers";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import InlineError from "../../UI/InlineError";
import { setInlineError } from "../../../store/AppState/actions";
var MyAttendeeCancel = function (_a) {
    var eventData = _a.eventData, attendee = _a.attendee;
    var _b = __read(useState(false), 2), showPopover = _b[0], setShowPopover = _b[1];
    var dispatch = useDispatch();
    var history = useHistory();
    var cancelAddon = function () {
        putCancelAttendee(attendee.id)
            .then(function (res) {
            if (res.status === 202) {
                dispatch(setPaymentRequiredPayload({
                    type: PaymentPayloadType.attendeeCancel,
                    payload: res.data,
                    originalFields: attendee.id,
                    summaryText: "",
                }));
            }
            else {
                var orderResult = res.data;
                handleSubmittedOrder(orderResult.result, eventData, history, true);
            }
        })
            .catch(function (err) {
            var _a, _b;
            handleErrors(err, dispatch, undefined, undefined, true);
            if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                dispatch(setInlineError({ cancelAttendeeError: err.response.data.message }));
            }
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("a", __assign({ onClick: function () { return setShowPopover(true); }, className: "no-underline dashboard-btn btn" }, { children: [_jsx(Icon, { icon: "x", classes: "m-right" }), _jsx("span", { children: "Cancel Add-on" })] })), _jsx("div", __assign({ onClick: function (evt) {
                    evt.stopPropagation();
                } }, { children: _jsxs(Modal, __assign({ closeButton: false, size: "sm", show: showPopover, setShow: setShowPopover }, { children: [_jsx(InlineError, { id: "cancelAttendeeError" }), _jsx(Form, __assign({ onSubmit: function () {
                                cancelAddon();
                            }, initialValues: {} }, { children: _jsxs(WidgetFieldset, { children: [_jsxs("h6", __assign({ className: "ta-center" }, { children: ["Are you sure you want to cancel this add-on?", _jsx("br", {}), "If you change your mind, you\u2019ll need to place a new order."] })), _jsxs("div", __assign({ className: "modal-footer border-0 p-0 p-top" }, { children: [_jsx(SubmitButton, __assign({ component: Button, type: "submit", purpose: "danger", customBusyIcon: _jsx(DotsLoader, { classes: "dots-button btn-spinner white" }), classes: "btn-sm btn-block p-0 m-0" }, { children: "Continue" })), _jsx(Button, __assign({ busy: false, type: "button", purpose: "plain", onClick: function () { return setShowPopover(false); }, classes: "btn-block clear-cart-cancel" }, { children: _jsx("small", { children: "Cancel" }) }))] }))] }) }))] })) }))] }));
};
export default MyAttendeeCancel;
